/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiAnalysisRunSampleType {
    RECENT_RUN = 'RECENT_RUN',
    TIMEFRAME = 'TIMEFRAME',
    SET = 'SET'
}


export function instanceOfInternalApiAnalysisRunSampleType(value: any): boolean {
    for (const key in InternalApiAnalysisRunSampleType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiAnalysisRunSampleType, key)) {
            if (InternalApiAnalysisRunSampleType[key as keyof typeof InternalApiAnalysisRunSampleType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiAnalysisRunSampleTypeFromJSON(json: any): InternalApiAnalysisRunSampleType {
    return InternalApiAnalysisRunSampleTypeFromJSONTyped(json, false);
}

export function InternalApiAnalysisRunSampleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAnalysisRunSampleType {
    return json as InternalApiAnalysisRunSampleType;
}

export function InternalApiAnalysisRunSampleTypeToJSON(value?: InternalApiAnalysisRunSampleType | null): any {
    return value as any;
}

export function InternalApiAnalysisRunSampleTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiAnalysisRunSampleType {
    return value as InternalApiAnalysisRunSampleType;
}

